"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _Voucher = _interopRequireDefault(require("./Voucher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = function Wrapper() {
  return /*#__PURE__*/_react.default.createElement(_Voucher.default, {
    minHeight: "140px"
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "100px",
    skeletonHeight: "100px",
    margin: "0 1rem 0 0"
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: "1 1 auto"
    }
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    display: "block",
    skeletonWidth: "180px",
    skeletonHeight: "14px",
    margin: "8px 0 14px"
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    display: "block",
    skeletonWidth: "120px",
    skeletonHeight: "14px",
    margin: "0 0 14px"
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    display: "block",
    skeletonWidth: "80px",
    skeletonHeight: "14px",
    margin: "0 0 0"
  })));
};

var _default = Wrapper;
exports.default = _default;